import { useState, useEffect, useRef } from 'react';
import supabase from '../supabase';

const bg = '#f0ebe3';
const red = '#6B1A1A';
const dark = '#4a1010';
const body = 'Cormorant Garamond, serif';

function Messages({ currentUserId, otherUserId, currentUserRole }) {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const bottomRef = useRef(null);

  useEffect(() => {
    fetchMessages();
    const channel = supabase
      .channel(`messages-${currentUserId}-${otherUserId}`)
      .on('postgres_changes', {
        event: 'INSERT',
        schema: 'public',
        table: 'messages'
      }, (payload) => {
        const msg = payload.new;
        if (
          (msg.sender_id === currentUserId && msg.receiver_id === otherUserId) ||
          (msg.sender_id === otherUserId && msg.receiver_id === currentUserId)
        ) {
          setMessages((prev) => [...prev, msg]);
        }
      })
      .subscribe();
    return () => supabase.removeChannel(channel);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUserId, otherUserId]);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchMessages();
    }, 3000);
    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const fetchMessages = async () => {
    const { data } = await supabase
      .from('messages')
      .select('*')
      .or(`and(sender_id.eq.${currentUserId},receiver_id.eq.${otherUserId}),and(sender_id.eq.${otherUserId},receiver_id.eq.${currentUserId})`)
      .order('created_at', { ascending: true });
    setMessages(data || []);
    setLoading(false);
  };

  const handleSend = async () => {
    if (!newMessage.trim()) return;
    const { error } = await supabase.from('messages').insert({
      sender_id: currentUserId,
      receiver_id: otherUserId,
      content: newMessage.trim(),
      sender_role: currentUserRole,
    });
    if (error) {
      alert('Error: ' + error.message);
    } else {
      setNewMessage('');
      fetchMessages();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  if (loading) return <p style={{ color: '#888', fontSize: '14px', fontFamily: body }}>Loading messages...</p>;

  return (
    <div style={{ border: '1px solid #d4c9bc', fontFamily: body }}>
      <div style={{ backgroundColor: dark, padding: '16px 24px' }}>
        <p style={{ color: '#c9a882', fontSize: '10px', letterSpacing: '3px', margin: 0 }}>MESSAGES</p>
      </div>
      <div style={{ height: '400px', overflowY: 'auto', padding: '24px', display: 'flex', flexDirection: 'column', gap: '12px', backgroundColor: bg }}>
        {messages.length === 0 ? (
          <p style={{ color: '#888', fontSize: '14px', fontStyle: 'italic', textAlign: 'center', marginTop: '160px' }}>No messages yet. Start the conversation.</p>
        ) : (
          messages.map((msg, i) => {
            const isMe = msg.sender_id === currentUserId;
            return (
              <div key={i} style={{ display: 'flex', justifyContent: isMe ? 'flex-end' : 'flex-start' }}>
                <div style={{
                  maxWidth: '70%',
                  padding: '12px 16px',
                  backgroundColor: isMe ? red : '#e8e2d9',
                  color: isMe ? '#f0ebe3' : '#2a1a1a',
                  fontSize: '14px',
                  lineHeight: '1.6',
                }}>
                  <p style={{ margin: '0 0 4px', fontSize: '10px', letterSpacing: '1px', opacity: 0.7 }}>
                    {msg.sender_role === 'admin' ? 'HERMES PARTNER CAPITAL' : 'YOU'}
                  </p>
                  <p style={{ margin: 0 }}>{msg.content}</p>
                  <p style={{ margin: '6px 0 0', fontSize: '10px', opacity: 0.6, textAlign: 'right' }}>
                    {new Date(msg.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                  </p>
                </div>
              </div>
            );
          })
        )}
        <div ref={bottomRef} />
      </div>
      <div style={{ borderTop: '0.5px solid #d4c9bc', padding: '16px 24px', display: 'flex', gap: '12px', backgroundColor: bg }}>
        <textarea
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Type a message... (Enter to send)"
          rows="2"
          style={{ flex: 1, backgroundColor: 'transparent', border: '0.5px solid #d4c9bc', padding: '10px 12px', fontSize: '14px', fontFamily: body, color: '#2a1a1a', outline: 'none', resize: 'none' }}
        />
        <button onClick={handleSend} style={{ backgroundColor: red, color: bg, padding: '0 24px', border: 'none', cursor: 'pointer', fontSize: '11px', letterSpacing: '2px', fontFamily: body }}>
          SEND
        </button>
      </div>
    </div>
  );
}

export default Messages;